// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wugub6zBNFoscK2w2jbh{padding:20px 20px 4px}.Wugub6zBNFoscK2w2jbh .EOx1CDXGnzMOOkJNL_hP{line-height:30px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapHeader": `Wugub6zBNFoscK2w2jbh`,
	"title": `EOx1CDXGnzMOOkJNL_hP`
};
export default ___CSS_LOADER_EXPORT___;
